import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactInformation from "./sections/ContactInformation";
import InquiryBookingForm from "./sections/InquiryBookingForm";
import MapDirections from "./sections/MapDirections";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactInformation />
      <InquiryBookingForm />
      <MapDirections />
      <Footer />
    </div>;
}